var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13316_46936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 3C13.5523 3 14 3.44772 14 4C14 4.51283 13.614 4.93551 13.1166 4.99327L13 5H5V19H19V11C19 10.4477 19.4477 10 20 10C20.5128 10 20.9355 10.386 20.9933 10.8834L21 11V19C21 20.0544 20.1841 20.9182 19.1493 20.9945L19 21H5C3.94564 21 3.08183 20.1841 3.00549 19.1493L3 19V5C3 3.94564 3.81588 3.08183 4.85074 3.00549L5 3H13ZM19.2426 3.34334C19.6331 2.95281 20.2663 2.95281 20.6568 3.34334C21.0173 3.70382 21.045 4.27105 20.74 4.66334L20.6568 4.75755L10.7573 14.657C10.3668 15.0476 9.73363 15.0476 9.34311 14.657C8.98262 14.2965 8.95489 13.7294 9.25992 13.337L9.34311 13.2428L19.2426 3.34334Z",
    fill: "#334B49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13316_46936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalEdit);
export default __webpack_public_path__ + "static/media/modalEdit.b872ade46c4846fdef4ff8cd100d58df.svg";
export { ForwardRef as ReactComponent };